import { useMemo } from "react";
import { useGetCompositeTypes } from "../../queries/QualityControlQueries";
import { useAddOrUpdateCompositeTypeMutation, useAddOrUpdateTestTypeMutation } from "../../queries/AdminQueries";
import { EntityTable } from "../../utilities/EntityTable";
import { EntityTableContainer } from "../../utilities/EntityTableContainer";

export const ManageCompositeTypes = () => {
    const { data, isLoading } = useGetCompositeTypes();

    const columnFields = useMemo(
        () => [
            { field: "id", headerName: "ID", flex: 2 },
            { field: "name", headerName: "Name", flex: 2, editable: true },
            { field: "description", headerName: "Description", flex: 2, editable: true },
            {
                field: "isActive",
                headerName: "Visible",
                flex: 2,
                type: "boolean",
                editable: true,
            },
        ],
        []
    );

    return (
        <>
            {data && (
                <EntityTableContainer
                    title="Composite Types"
                    table={
                        <EntityTable
                            entity={data}
                            columnFields={columnFields}
                            useAddOrUpdateEntity={useAddOrUpdateCompositeTypeMutation}
                            isLoading={isLoading}
                        />
                    }
                />
            )}
        </>
    );
};
